// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.levelChk[data-v-5e4e3f4f] {\n  display: inline-block;\n  position: relative;\n  min-width: 15px;\n  min-height: 22px;\n  line-height: 22px;\n  cursor: pointer;\n  word-break: keep-all;\n  opacity: 1;\n}\n.popup_wrap[data-v-5e4e3f4f] {\n    overflow-y: auto !important;\n    overflow-x: hidden !important;\n}\n", ""]);
// Exports
module.exports = exports;
